var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasImage)?_c('b-avatar',{attrs:{"src":_vm.getImage(_vm.img),"size":_vm.size + 'em',"alt":""}}):_c('b-avatar',{attrs:{"src":require('@/assets/paw_print.png'),"size":_vm.size + 'em',"alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }